export default "__VITE_ASSET__DjzpqyK3__"